module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAASElEQVRIiWNkWPCSgUzwH0ozkqOZiVxbKQWjFo9aPGrxqMWjFg9+i1kYELUMuYAs/QPqY7LqU4bR+njU4lGLRy0etXjUYloBALupBciwH2Y0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/support/矩形1.png
// module id = AzO0
// module chunks = 1